import React from "react";

import * as dispatchStyles from "../../../styles/widgets/dispatch.module.scss";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {useTranslation} from "react-i18next";
import {altNN} from "../../../utils/parsing";
import IconContainer from "../IconContainer";
import PolyLink from "../PolyLink";


const Dispatch = ({title, link, link_text, image, content}) => {
    const {t} = useTranslation();

    return (
        <PolyLink
            url={link}
            className={dispatchStyles.root}
        >
            {image?.imageFile &&
                <GatsbyImage
                    image={getImage(image.imageFile)}
                    style={{height: "100%"}}
                    alt={altNN(title)}
                    className={dispatchStyles.image}
                />
            }
            <div className={dispatchStyles.container}>
                <p className={dispatchStyles.title}>
                    {title}
                </p>
                <p className={dispatchStyles.content}>
                    {content}
                </p>
                <div className={dispatchStyles.containerMore}>
                    <p className={dispatchStyles.more}>
                        {link_text || t("internal.page.more")}
                    </p>
                    <div className={dispatchStyles.arrowHover}>
                        <IconContainer
                            classname={dispatchStyles.icon}
                            icon="ARROW_RIGHT_NORMAL"
                            color="BLACK"
                            size={20}
                        />
                    </div>
                </div>
            </div>
        </PolyLink>
    )
}

export default Dispatch;